module.exports = __webpack_public_path__ + "img/gdq_gbt97_1_1985.prt.4015f760.jpg";